module.exports = __webpack_public_path__ + "static/media/googleLogo.3ec228d3.svg";